import { SimpleGrid, VStack } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import RecentView from 'pages/DashboardPage/components/RecentView'
import WelcomeMessage from 'pages/DashboardPage/components/WelcomeMessage'
import DraftView from './components/DraftView'
import FavoriteView from './components/FavoriteView'
import WorkPlanView from './components/WorkPlanView'
import PriorityUpdatesView from './components/PriorityUpdatesView'
import SurveyPopup from './components/SurveyPopup'

const DashboardPage = () => {
  const { authStore, organizationStore } = useStores()
  const { isShowSurveyPopup } = authStore
  const { organization } = organizationStore
  const isWorkPlanEnabled = organization?.isWorkPlanEnabled !== false
  const isPriorityUpdateEnabled = organization?.isPriorityUpdateEnabled !== false

  return (
    <VStack spacing={4} width="full" alignItems="flex-start">
      <WelcomeMessage />
      <RecentView />
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} width="full">
        {isPriorityUpdateEnabled && <PriorityUpdatesView />}
        {isWorkPlanEnabled && <WorkPlanView />}
        <FavoriteView />
        <DraftView />
      </SimpleGrid>
      {isShowSurveyPopup && (
        <SurveyPopup isOpen={isShowSurveyPopup} onClose={() => authStore.setShowSurveyPopup(false)} />
      )}
    </VStack>
  )
}

export default observer(DashboardPage)